import { IconMail, IconMailOpened } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const MailSettingsPage = lazy(() => import("./MailSettingsPage").then((m) => ({ default: m.MailSettingsPage })));
const MailMessagesPage = lazy(() => import("./MailMessagesPage").then((m) => ({ default: m.MailMessagesPage })));
const page = createElement(Suspense, { fallback: null }, createElement(MailSettingsPage));
const history = createElement(Suspense, { fallback: null }, createElement(MailMessagesPage));

export const routes: FeatureRoute[] = [
  { path: "/admin/settings/mail", roles: CAPS.admin.mail, element: page },
  { path: "/admin/settings/mail/messages", roles: CAPS.admin.mail, element: history },
];

export const nav: NavItem[] = [
  { label: "Mail settings", path: "/admin/settings/mail", icon: IconMail, surface: "admin", roles: CAPS.admin.mail },
  {
    label: "Mail history",
    path: "/admin/settings/mail/messages",
    icon: IconMailOpened,
    surface: "admin",
    roles: CAPS.admin.mail,
  },
];
